export enum LogLevel {
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'error',
    DEBUG = 'debug'
}

export interface Log {
    _id?: string;
    timestamp: Date;
    level: LogLevel;
    message: string;
    userId?: string;
    metadata?: Record<string, any>;
    source: string;
    ip?: string;
}

export interface LogListParams {
    page: number;
    per_page: number;
    total: number;
    startDate?: string;
    endDate?: string;
    level?: LogLevel;
    search?: string;
} 